import React, { forwardRef, RefObject, useRef } from 'react';

import classNames from 'classnames';
import { Modifier, Placement } from '@popperjs/core';

import { Popper } from '../Popper';

import './Popup.scss';

export type PopupProps = React.HTMLAttributes<HTMLDivElement> & {
    readonly target: RefObject<HTMLElement>;
    readonly visible: boolean;
    readonly placement: Placement;
    readonly className?: string;
    readonly gap?: number;
    readonly displacement?: number;
    readonly onClose?: (visible: false) => void;
    readonly arrow?: boolean;
    readonly portal?: boolean;
    readonly theme?: PopupTheme;
    readonly popupClassName?: string;
    readonly modifiers?: Modifier<any, any>[];
};

export enum PopupTheme {
    LIGHT = 'theme-light',
    DARK = 'theme-dark',
    PLAYER = 'theme-player',
    NONE = 'theme-none',
    CUSTOM = ''
}

export const Popup = forwardRef<HTMLDivElement, PopupProps>(
    (
        {
            target,
            visible,
            placement,
            className,
            children,
            gap = 12,
            displacement = 0,
            popupClassName = 'popup',
            onClose,
            arrow = true,
            portal,
            theme = PopupTheme.NONE,
            modifiers = [],
            ...props
        },
        ref
    ) => {
        const arrowRef = useRef<HTMLDivElement>(null);

        return (
            <Popper
                {...props}
                ref={ref}
                visible={visible}
                placement={placement}
                className={classNames(popupClassName, className, theme)}
                referenceElement={target}
                arrowElement={arrowRef}
                gap={gap}
                displacement={displacement}
                onClickOutside={onClose}
                portal={portal}
                modifiers={modifiers}
            >
                {arrow && <div ref={arrowRef} className="popup-arrow" />}
                <div className="popup-content">{children}</div>
            </Popper>
        );
    }
);
